import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseEntityService } from "../rest-common.service";
import { NotificationService } from "src/app/notification.service";

@Injectable({
  providedIn: "root",
})
export class BdspLineItemService extends BaseEntityService {
  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }

  public resource_url = `${this.BASE_BDSP_URL}/line-item/`;

  activateDeactiveLineItem(
    id: number,
    action: "activate" | "deactivate",
    params = {}
  ) {
    let url = this.buildUrl(`${this.resource_url}${id}/${action}/`, "", params);
    return this.patch(url, {});
  }

  getMetaData(params){
    let url = this.buildUrl(`${this.resource_url}` + 'li-meta', "", params);
    return this.getFile(url)
  }
}

@Injectable({
  providedIn: "root",
})
export class BdspPlacementIdService extends BaseEntityService {
  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }

  public resource_url = `${this.BASE_BDSP_URL}/placement-id-validate/`;

  validatePlacementId(data = {}, params = {}) {
    let url = this.buildUrl(`${this.resource_url}`, "", params);
    return this.post(url, data);
  }
}
